const actionTypes = {
  SetShowSecurityChecksPage: 'secure/SET_SHOW_SECURITY_CHECKS_PAGE',
  SetSecurityCheck: 'secure/SET_SECURITY_CHECK',
}

const initialState = {
  showSecurityChecksPage: undefined,
  securityCheck: null,
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SetShowSecurityChecksPage:
      return {
        ...state,
        showSecurityChecksPage: action.payload.showSecurityChecksPage,
      }
    case actionTypes.SetSecurityCheck:
      return {
        ...state,
        securityCheck: action.payload.securityCheck,
      }
    default:
      return state
  }
}

export const actions = {
  setShowSecurityChecksPage: (showSecurityChecksPage) => ({
    type: actionTypes.SetShowSecurityChecksPage,
    payload: { showSecurityChecksPage },
  }),
  setSecurityCheck: (securityCheck) => ({
    type: actionTypes.SetSecurityCheck,
    payload: { securityCheck },
  }),
}
